import React, { Fragment } from "react";

import classes from "./index.module.scss";
import { Product } from "../../../payload/payload-types";
import { GrClose } from "react-icons/gr";
import CartItem from "../../(pages)/cart/CartItem";
import { useCart } from "../../_providers/Cart";
import { Button } from "../Button";
import { useAuth } from "../../_providers/Auth";
import CartItemQuickAdd from "./CartItemQuickAdd";
import { useQuickAdd } from "../../_providers/QuickCart";

export const QuickAddToCart: React.FC<{
  product?: Product;
}> = (props) => {
  const { product } = props;

  const { user } = useAuth();
  const { cart, cartIsEmpty, addItemToCart, cartTotal, hasInitializedCart } =
    useCart();

  const { quickAdd, setQuickAdd } = useQuickAdd();

  return (
    <section className={classes.quickAddSection}>
      <div className={classes.closeHide} onClick={() => setQuickAdd(false)}>
        <GrClose size={20} color="#000000" />
      </div>
      <div className={classes.cartContainer}>
        <div className={classes.cartWrapper}>
          <table>
            <tbody className={classes.tbody}>
              <thead>
                <tr>
                  <th className={classes.th}>Products</th>
                  <th className={classes.th}>Quantity</th>
                  <th className={classes.th}>Subtotal</th>
                  <th className={classes.th}>Action</th>
                </tr>
              </thead>

              {/* CART ITEM LIST */}
              {/*<div className={classes.itemsList}>*/}
              {cart?.items?.map((item, index) => {
                if (typeof item.product === "object") {
                  const {
                    size,
                    color,
                    variation,
                    quantity,
                    product,
                    product: { id, title, meta },
                  } = item;

                  const isLast = index === (cart?.items?.length || 0) - 1;

                  const metaImage = meta?.image;

                  return (
                    <Fragment key={index}>
                      <CartItemQuickAdd
                        product={product}
                        title={title}
                        metaImage={metaImage}
                        qty={quantity}
                        variation={variation}
                        addItemToCart={addItemToCart}
                      />
                    </Fragment>
                  );
                }
                return null;
              })}
              {/*</div>*/}
            </tbody>
          </table>

          <div className={classes.summary}>
            <div className={classes.row}>
              <h6 className={classes.cartTotal}>Summary</h6>
            </div>

            <div className={classes.row}>
              <p className={classes.cartTotal}>
                <strong>Delivery Charge</strong>
              </p>
              <p className={classes.cartTotal}>
                Charges to be displayed at checkout
              </p>
            </div>

            <div className={classes.row}>
              <p className={classes.cartTotal}>
                <strong>Grand Total</strong>
              </p>
              <p className={classes.cartTotalValue}>{cartTotal.formatted}</p>
            </div>

            <Button
              className={classes.checkoutButton}
              href={user ? "/checkout" : "/login?redirect=%2Fcheckout"}
              label={user ? "Checkout" : "Login to checkout"}
              appearance="primary"
            />

            {!user && (
              <Button
                className={classes.guestCheckoutButton}
                href={"/guestcheckout"}
                label={"Guest checkout"}
                appearance="primary"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
